<template>
  <div>
    <div class="proxy-box">
      <ul>
        <li v-if="data && data.items && data.items[0]">
          今日人数
          <a class="val"
            ><span style="font-size: 20px; font-weight: 600; color: red">{{
              data.items[0].team_count
            }}</span
            >&nbsp;<span style="font-size: 14px">人</span></a
          >
        </li>
        <li style="border: none" v-if="data">
          团队人数
          <a class="val"
            ><span style="font-size: 20px; font-weight: 600; color: green">{{
              data.total_team_count
            }}</span
            >&nbsp;<span style="font-size: 14px">人</span></a
          >
          <div
            style="
              width: 90%;
              margin: 5px auto;
              text-align: center;
              line-height: 1.6;
              border: 1px solid #3e435d;
              border-radius: 10px;
              padding: 10px;
            "
            @click="$router.push({ name: 'team' })"
          >
            查看列表
          </div>
        </li>
      </ul>
    </div>
    <div v-for="(item, index) in list" :key="index">
      <div class="proxy-box" v-if="data && data.items && data.items[index]">
        <div class="title">{{ item.label }}</div>
        <ul>
          <li>
            团队人数
            <a class="val"
              ><span style="font-size: 20px; font-weight: 600">{{
                data.items[index].team_count
              }}</span
              >&nbsp;<span style="font-size: 14px">人</span></a
            >
          </li>
          <li>
            充值人数
            <a class="val"
              ><span style="font-size: 20px; font-weight: 600">{{
                data.items[index].recharge_count
              }}</span></a
            >
          </li>
          <li>
            充值总额
            <a class="val"
              ><span style="font-size: 20px; font-weight: 600; color: green">{{
                data.items[index].recharge_amount
              }}</span></a
            >
          </li>
          <li>
            提现总额
            <a class="val"
              ><span style="font-size: 20px; font-weight: 600; color: red">{{
                data.items[index].withdrawal_amount
              }}</span></a
            >
          </li>
          <li>
            打码量
            <a class="val"
              ><span style="font-size: 20px; font-weight: 600">{{
                data.items[index].coded_volume
              }}</span></a
            >
          </li>
          <li style="border: none">
            盈亏
            <a class="val"
              ><span style="font-size: 20px; font-weight: 600">{{
                data.items[index].loss
              }}</span></a
            >
          </li>
        </ul>
      </div>
    </div>
    <div style="margin-bottom: 30px">&nbsp;</div>
  </div>
</template>

<script>
export default {
  name: 'TeamView',
  data () {
    return {
      list: [
        { label: '今日' },
        { label: '昨日' },
        { label: '本周' },
        { label: '上周' },
        { label: '本月' },
        { label: '上月' }
      ],
      data: {}
    }
  },
  mounted () {
    this.GetAgentReportSummary()
  },
  methods: {
    async GetAgentReportSummary () {
      await this.$http({
        method: 'post',
        url: 'AgentReportSummary'
      }).then(data => {
        this.data = data.data
      })
    }
  }
}
</script>

<style></style>
